import { action as apiAction } from 'api/Api'
import {
  removeLabel
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  labelId: number
}

const requestRemoveLabel = (payload: Payload) => async dispatch => {
  const { cardId, labelId } = payload

  const optimisticAction = optimisticDispatch(dispatch, removeLabel({
    id: cardId,
    labelId
  }))

  try {
    await apiAction('RemoveLabelFromCard', {
      cardId,
      labelId
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}

export default requestRemoveLabel
